<template>
  <EntryField
    v-model="modelValue"
    data-refid="mappingRuleEntryDate"
    :label
    :json-data
    :disabled
  >
    <div
      v-if="!isMappedFromJson"
      class="flex-auto"
    >
      <DSFieldLabel
        v-if="label"
        :id="labelId"
        :label
        class="mb-1.5"
      />
      <DSDateField
        v-model="inputValue"
        :aria-labelledby="label ? labelId : undefined"
        :aria-label="label ? undefined : 'Date'"
        :size="toDSInputSize(size)"
      />
    </div>
  </EntryField>
</template>

<script setup lang="ts">
import { computed, inject, nextTick, useId, watch } from 'vue'

import { InputSize } from '@types'
import { MappingRuleActionField } from '../utils/types'

import { getCurrentDate } from '@/helpers/dates'

import { toDSInputSize } from '@/components/UI/Input/utils/helpers'

import EntryField from './EntryField.vue'
import { DSDateField, DSFieldLabel } from '@ds'

type Props = {
  label?: string
  jsonData?: Record<string, unknown>
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<MappingRuleActionField>()

const size = inject<InputSize>('size')

const labelId = useId()

const inputValue = computed({
  get() {
    return modelValue.value?.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value,
    }
  },
})

const isMappedFromJson = computed(() => modelValue.value?.isMappedFromJson)

watch(isMappedFromJson, mapped => {
  if (mapped) return
  nextTick(() => {
    inputValue.value = getCurrentDate({})
  })
})
</script>
